// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    createHandlerChainRunner,
    Handler,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { getDefaultPageSize } from "@insite/client-framework/Store/Context/ContextSelectors";
import loadCompanySavedAddresses from "@pacific/App/Handlers/Addresses/LoadCompanySavedAddresses";
import { deleteCompanySavedAddress as deleteCompanySavedAddressApi } from "@pacific/App/Services/CompanySavedAddressesService";
import { CustomAppState } from "@pacific/App/Store/Reducers";

type HandlerType = Handler<
    {
        addressId: string;
        reloadCompanySavedAddresses?: boolean;
        onSuccess?: () => void;
    },
    {
        error: boolean;
    }
>;

export const DispatchBeginDeleteCompanySavedAddress: HandlerType = props => {
    props.dispatch({
        type: "xCompanySavedAddresses/BeginDeleteCompanySavedAddress",
    } as any);
};

export const RequestRemoveCompanySavedAddress: HandlerType = props => {
    return deleteCompanySavedAddressApi({ addressId: props.parameter.addressId }).then(() => {
        props.error = false;
    });
};

export const ResetCompanySavedAddressesData: HandlerType = props => {
    props.dispatch({
        type: "xCompanySavedAddresses/Reset",
    } as any);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (!props.error) {
        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.();
    }
};

export const DispatchCompleteDeleteCompanySavedAddress: HandlerType = props => {
    props.dispatch({
        type: "xCompanySavedAddresses/CompleteDeleteCompanySavedAddress",
    } as any);
};
export const DispatchSendNewPageSize: HandlerType = props => {
     const state = props.getState() as CustomAppState;  
    props.dispatch({
        type: "xCompanySavedAddresses/SetPageSize",
        pageSize: getDefaultPageSize(state),
    } as any);
};

export const DispatchLoadCompanySavedAddresses: HandlerType = props => {
    if (props.parameter.reloadCompanySavedAddresses) {
        props.dispatch(loadCompanySavedAddresses());
    }
};

export const chain = [
    DispatchBeginDeleteCompanySavedAddress,
    RequestRemoveCompanySavedAddress,
    ResetCompanySavedAddressesData,
    ExecuteOnSuccessCallback,
    DispatchCompleteDeleteCompanySavedAddress,
    DispatchSendNewPageSize,
    DispatchLoadCompanySavedAddresses,
];

const deleteCompanySavedAddress = createHandlerChainRunner(chain, "DeleteCompanySavedAddress");
export default deleteCompanySavedAddress;
